import { useState } from 'react';

import { Lock, Send } from 'lucide-react';

import { useRequestCaseAccess } from '../../../api/mutations/useRequestCaseAccess';
import { Button } from '../../atoms/new-button';
import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';

interface RequestMatterAccessProps {
  caseId: string | null;
}

export const RequestMatterAccess = ({ caseId }: RequestMatterAccessProps) => {
  const [accessRequested, setAccessRequested] = useState(false);
  const requestCaseAccessMutation = useRequestCaseAccess();
  const handleRequestCaseAccess = () => {
    if (!caseId) return;
    trackCustomEvent(TrackingEvents.RequestMatterAccess);
    requestCaseAccessMutation.mutate(caseId);
  };
  return (
    <div className="flex w-full justify-center px-4 pt-20 pb-10 md:pt-32">
      <div className="relative w-full max-w-md rounded-xl border border-gray-200 bg-white p-6 text-center shadow-lg md:p-10">
        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-blue-50 to-gray-100 opacity-50"></div>

        {/* Content */}
        <div className="relative flex flex-col items-center gap-7 text-gray-500">
          <div className="mb-2 flex h-20 w-20 items-center justify-center rounded-full bg-blue-100">
            <Lock className="h-10 w-10 text-blue-600" />
          </div>

          <div className="flex flex-col items-center gap-2">
            <h2 className="mb-1 text-2xl font-semibold text-gray-800">No Access</h2>
            <div className="text-sm leading-relaxed md:text-base">
              <p>You do not have permission to view this matter.</p>
            </div>
          </div>

          {accessRequested ? (
            <p className="mt-2 text-sm">
              Access request sent. You will be notified when you have been added to this matter.
            </p>
          ) : (
            <>
              <p className="mb-2 text-sm">
                Click the button below to send an access request to the matter owner. Or reach out to your IT
                administrator.
              </p>

              <Button
                variant="primary"
                className="flex w-full items-center justify-center gap-2 md:w-auto"
                onClick={() => {
                  handleRequestCaseAccess();
                  setAccessRequested(true);
                }}
              >
                Request Access
                <Send className="h-4 w-4" />
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
